jQuery(document).ready(function ($) {
    try {
    // ========================================
    // Initialize Foundation
    // ========================================
    $(document).foundation();

    // ========================================
    // Foundation Reveal Event Listener
    // ========================================
    $(document).on('open.zf.reveal', '[data-reveal]', function () {
        $(window).trigger('resize');
    });
        document.addEventListener('facetwp-loaded', function() {
            $(document).foundation(); // Tells Foundation to look for new [data-reveal] items
        });
    // ========================================
    // Animation: Slide graphics on scroll
    // ========================================
    $(window).scroll(function () {
        $(".animate").each(function () {
            var imagePos = $(this).offset().top;
            var topOfWindow = $(window).scrollTop();
            var halfWindow = $(window).height() * 0.5;
            var threeQuaterWindow = $(window).height() * 0.9;
            // console.log('Image position =' + imagePos + ' Top of Window =' + topOfWindow + 'halfWindow = ' + halfWindow);
            if (imagePos < topOfWindow + threeQuaterWindow) {
                $(this).addClass("slideUp");
            }
            if (imagePos > topOfWindow + threeQuaterWindow) {
                $(this).removeClass("slideUp");
            }
        });
    });
        $(window).on('scroll', function() {
            var scrollPos = $(this).scrollTop();
            // Adjust 45 to the actual height of your ancillary bar
            if (scrollPos > 155) {
                $('.header-wrapper').addClass('is-scrolled');
            } else {
                $('.header-wrapper').removeClass('is-scrolled');
            }
        });
    // ========================================
    // Read More Toggle for Text Module
    // ========================================
    $(".more-text-module").each(function () {
        var moretextId = $(this).data("moretextid");
        $('#more-less-button_'+ moretextId ).click(function () {
            console.log('clicked' + moretextId);
            $('#more-text_' + moretextId ).slideToggle();
            if ($('#more-less-button_' +  moretextId ).text() === "Read More +") {
                $(this).text("Read Less -")
            } else {
                $(this).text("Read More +")
            }
        });
    });

    // ========================================
    // Video Player for YouTube or Vimeo
    // ========================================
    $('.VideoPlayButton.vimeo').click(function () {
        var videoId = $(this).data('videoid');
        $(this).fadeOut(300, function () {
            $('#VideoContainer_' + videoId).fadeIn(300, function () {
                $('#VideoFrame_' + videoId).attr('src', 'https://player.vimeo.com/video/' + videoId + '?color=ffffff&byline=0&portrait=0&autoplay=1');
            });
        });
    });

    $('.VideoPlayButton.youtube').click(function () {
        var videoId = $(this).data('videoid');
        $(this).fadeOut(300, function () {
            $('#VideoContainer_' + videoId).fadeIn(300, function () {
                $('#VideoFrame_' + videoId).attr('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
            });
        });
    });

    // ========================================
    // Slick Slider Initialization
    // ========================================
    window.addEventListener('load', function() {
        console.log('🎬 Starting Slick initialization...');

        // Check if Slick is available
        if (typeof $.fn.slick === 'undefined') {
            console.error('❌ Slick.js not loaded! Check that slick.js is properly enqueued.');
            return;
        }

        try {
            // SLICKJS SLIDERS
            console.log('Initializing carousel-hero...');
            $('.carousel-hero').slick({
                dots: false,
                arrows: true,
                infinite: true,
                slide: 'div',
                speed: 300,
                autoplay: true,
                autoplaySpeed: 6000,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                cssEase: 'linear',
                accessibility: false, // Prevents Slick from fighting with the browser over focus
                focusOnSelect: false
            });
            console.log('✅ carousel-hero initialized');

            console.log('Initializing carousel-hero-mobile...');
            $('.carousel-hero-mobile').slick({
                dots: false,
                arrows: true,
                infinite: true,
                slide: 'div',
                speed: 300,
                autoplay: true,
                autoplaySpeed: 6000,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                cssEase: 'linear',
                accessibility: false,
            });
            console.log('✅ carousel-hero-mobile initialized');

            console.log('Initializing quote-slider...');
            $('.quote-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 6000,
                dots: false,
                accessibility: false,
            });
            console.log('✅ quote-slider initialized');

            console.log('Initializing content-sliders...');
            $(".content-slider").each(function () {
                var $slider = $(this);
                var slideid = $slider.data("slideid");

                // Defensive check: only init if there are actual slides (columns) inside
                if ($slider.children().length > 0) {
                    var slidesnumber = $slider.data("slidestoshow") || 1;
                    var slidesscroll = $slider.data("slidestoscroll") || 1;
                    var showarrows   = $slider.data("arrows") == true;
                    var showdots     = $slider.data("dots") == true;

                    $slider.slick({
                        slidesToShow: slidesnumber,
                        slidesToScroll: slidesscroll,
                        arrows: showarrows,
                        dots: showdots,
                        speed: 300,
                        autoplay: true,
                        autoplaySpeed: 6000,
                        accessibility: false // Turning this off stops the 'initADA' null error
                    });
                    console.log('✅ Slider ' + slideid + ' initialized.');
                } else {
                    console.warn("⚠️ Slider " + slideid + " found but has no slides inside. Skipping.");
                }
            });



                // Defensive check: only init if there are actual slides (columns) inside
                $('.video-slider').each(function () {
                    var $slider = $(this);
                    var slideid = $slider.data('slideid') || $slider.attr('id') || '';

                    // Look for actual slides in this slider
                    var $slides = $slider.children('.video-slide');
                    if ($slides.length === 0) {
                        // fallback if you ever change markup
                        $slides = $slider.children('div');
                    }

                    if ($slides.length === 0) {
                        console.warn('⚠️ Slider ' + slideid + ' has no slides. Skipping.');
                        return;
                    }

                    // Prefer data-slick JSON if present
                    var slickData = $slider.attr('data-slick');
                    var opts = {};
                    if (slickData) {
                        try { opts = JSON.parse(slickData); } catch (e) {}
                    }
                    var max = opts.slidesToShow || 3;
                    // Defaults (and allow override via JSON)
                    opts = $.extend(true, {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        speed: 300,
                        autoplay: true,
                        autoplaySpeed: 6000,
                        accessibility: false,
                        mobileFirst: true,
                        responsive: [
                            { breakpoint: 320,  settings: { slidesToShow: Math.min(1, max) } },
                            { breakpoint: 640,  settings: { slidesToShow: Math.min(2, max) } },
                            { breakpoint: 1024, settings: { slidesToShow: Math.min(3, max) } }

                        ]
                    }, opts);

                    // Avoid double-init
                    if ($slider.hasClass('slick-initialized')) return;

                    $slider.slick(opts);
                    console.log('✅ Slider ' + slideid + ' initialized.', opts);
                });


            console.log('Initializing gallery-photo...');
            $('.gallery-photo').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 6000,
                asNavFor: '.gallery-thumb',
                accessibility: false,
            });
            console.log('✅ gallery-photo initialized');

            console.log('Initializing gallery-thumb...');
            $('.gallery-thumb').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.gallery-photo',
                dots: false,
                centerMode: true,
                focusOnSelect: true,
                mobileFirst: true,
                accessibility: false,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                        }
                    }
                ]
            });
            console.log('✅ gallery-thumb initialized');
            console.log('🎬 All Slick sliders initialized successfully!');
        } catch (slickError) {
            console.error('❌ Error during Slick initialization:', slickError);
            console.error('Stack:', slickError.stack);
        }
    });
    // Pause slider if video is played
        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.VideoPlayButton');
            if (!btn) return;

            // Pause the nearest slick slider
            const slider = btn.closest('.slick-slider, .video-slider');
            if (slider && typeof jQuery !== 'undefined') {
                const $slider = jQuery(slider);
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('slickPause');
                }
            }
        });

    // ========================================
    // Rellax Parallax Initialization
    // ========================================
        window.addEventListener('load', function() {
            // Wait slightly for Slick to finish its layout shifts
            setTimeout(function() {
                try {
                    // Check if the library exists AND the element is on the page
                    if (typeof Rellax !== 'undefined' && $('.rellax').length > 0) {
                        var rellax = new Rellax('.rellax', {
                            vertical: true,
                            horizontal: false
                        });
                        console.log('✅ Rellax initialized');
                    }
                } catch (e) {
                    console.warn('⚠️ Rellax initialization skipped:', e.message);
                }
            }, 300);
        }, { once: true });

    // ========================================
    // Fancybox Image Gallery Initialization
    // ========================================
    function waitForFancybox(attempts = 0) {
        if (window.Fancybox && typeof window.Fancybox.bind === 'function') {
            console.log("✅ Fancybox available, binding...");
            Fancybox.bind("[data-fancybox]", {
                groupAll: true,
                animated: true,
                showClass: "f-fadeIn",
                hideClass: "f-fadeOut",
                hideScrollbar: true,
                dragToClose: true,
                closeButton: "auto",
                placeFocusBack: false,
                // Add the theme's brand class so our CSS can target this dialog
                // specifically without touching other Fancybox usage elsewhere.
                mainClass: "aktiv-fancybox",
                Carousel: {
                    transition: "fade",
                    friction: 0.78,
                },
                Toolbar: {
                    display: {
                        left: ["infobar"],
                        middle: [],
                        right: ["slideshow", "fullscreen", "thumbs", "close"],
                    },
                },
                Thumbs: {
                    type: "modern",
                    showOnStart: false,
                },
            });
        } else if (attempts < 10) {
            console.log("⏳ Waiting for Fancybox...");
            setTimeout(() => waitForFancybox(attempts + 1), 100);
        } else {
            console.warn("❌ Fancybox not found after 1s");
        }
    }

    waitForFancybox();
    } catch (e) {
        // Catch any errors from extensions or initialization
        console.warn('App initialization error:', e);
    }
// Global Search overlay
    jQuery(function ($) {

        const $trigger  = $('.js-open-search');
        const $form     = $('.js-global-search');
        const $input    = $form.find('input.global-search-input');
        const $closeBtn = $form.find('.js-close-search');

        // Portal the form out to <body> so it isn't trapped inside the
        // .header-wrapper stacking context (which uses transforms on scroll).
        if ($form.length && $form.parent().get(0) !== document.body) {
            $form.appendTo('body');
        }

        // Inject the backdrop once, just before the form
        let $backdrop = $('.global-search-backdrop');
        if (!$backdrop.length) {
            $backdrop = $('<div class="global-search-backdrop" aria-hidden="true"></div>').insertBefore($form);
        }

        function openSearch() {
            $form.addClass('is-active').attr('aria-hidden', 'false');
            $backdrop.addClass('is-active');
            $trigger.attr('aria-expanded', 'true');
            $input.attr('tabindex', '0');
            $('body').addClass('global-search-open');
            window.setTimeout(function () { $input.trigger('focus'); }, 60);
        }

        function closeSearch() {
            if (!$form.hasClass('is-active')) return;
            $form.removeClass('is-active').attr('aria-hidden', 'true');
            $backdrop.removeClass('is-active');
            $trigger.attr('aria-expanded', 'false');
            $input.attr('tabindex', '-1').trigger('blur');
            $('body').removeClass('global-search-open');
        }

        $trigger.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($form.hasClass('is-active')) closeSearch(); else openSearch();
        });

        $closeBtn.on('click', function (e) {
            e.preventDefault();
            closeSearch();
        });

        $backdrop.on('click', closeSearch);

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') closeSearch();
        });

    });
});
// ========================================================
// Optimized Foundation Reveal Safety-Net Handler
// ========================================================
jQuery(function ($) {
    if (typeof Foundation !== 'undefined' && $('#product-reveal-modal').length) {
        $('#product-reveal-modal').foundation();
    }

    // Listens directly at the document layer for absolute reliability
    $(document).on('click', '.js-manual-close, .reveal-overlay', function (e) {
        // Ensure the click didn't happen inside the actual image asset
        if ($(e.target).closest('.lightbox-reveal-box__image').length === 0) {
            e.preventDefault();

            // 1. Tell Foundation to natively animate closed
            $('#product-reveal-modal').foundation('close');

            // 2. The Bulletproof Cleanup: Forcefully unlock browser scrolling
            // This guarantees the page is interactive even if an animation glitched
            $('html, body').removeClass('is-reveal-open').css({
                'overflow': '',
                'position': '',
                'height': ''
            });
        }
    });

    // Safety hook: If the user presses the ESC key, ensure scroll unlocks too
    $(document).on('closed.zf.reveal', '#product-reveal-modal', function() {
        $('html, body').removeClass('is-reveal-open').css('overflow', '');
    });
});